import { atom } from 'jotai'
export const typeCommandeAtom = atom('course-a-course')
export const totalDistance = atom(0)
export const typeTransportAtom = atom(null)
export const temporisationAtom = atom("immediat")
export const typeEtageAtom = atom(null)
export const nombreEtagesAtom = atom(null)
export const rippeursAtom = atom(null)
export const dangerAtom = atom(false)
export const rippeurHoursAtom = atom(null)
export const optionsPoidsLourdsAtom = atom(null)
export const optionsVehiculeLegerAtom = atom(null)
export const priceMissionsAtom = atom([])
export const isSimulationVisibleAtom = atom(false);


export function computePriceCourseACourse(
	tarif,
	typeCommande,
	typeTransport,
	distance,
	temporisation,
	nombreEtages,
	typeEtage,
	rippeurs,
	rippeurHours,
	optionsVehiculeLeger,
	optionsPoidsLourds,
	danger
) {
	const distanceKM = distance / 1000

	// Table de correspondance pour récupérer la clé de tarif
	const tarifMap = {
		'Break': tarif.BREAK,
		'Fourgon 12m³': tarif.F12,
		'Fourgon 14m³': tarif.F14,
		'Camion 20m³': tarif.F20,
		'7,5 Tonnes': tarif.V7_5T,
		'12 Tonnes': tarif.V12T,
		'19 Tonnes': tarif.V19T,
		'Tracteur': tarif.TRACTEUR,
		'Tracteur+semi': tarif.TRACTEUR_SEMI,
	}

	const currentTarif = tarifMap[typeTransport]
	if (!currentTarif) return 0

	console.log('danger',danger)
	// Choix du tarif au km
	const perKM = temporisation === 'planifie' ? currentTarif.PLANIFIE : currentTarif.IMMEDIAT

	let _price = distanceKM * perKM + currentTarif.Tarif_DE_PRISE_EN_CHARGE

	// Gestion des étages
	const etagesMap = {
		'1-10': currentTarif.TARIF_PAR_1_10_ETAGE,
		'11-20': currentTarif.TARIF_PAR_11_20_ETAGE,
		'21-30': currentTarif.TARIF_PAR_21_30_ETAGE,
	}
	if (etagesMap[nombreEtages]) {
		_price += etagesMap[nombreEtages]
	}

	// Rippeurs
	if (rippeurs && rippeurHours) {
		_price += Number(rippeurHours) * Number(rippeurs) * currentTarif.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
	}

	// Options frigorifique
	const isLightVehicle = ['Break', 'Fourgon 12m³', 'Fourgon 14m³', 'Camion 20m³'].includes(typeTransport)
	const options = isLightVehicle ? optionsVehiculeLeger : optionsPoidsLourds
	if (options && options.includes('Frigorifique')) {
		_price += (distanceKM * perKM + currentTarif.Tarif_DE_PRISE_EN_CHARGE) * (currentTarif.FRIGORIFIQUE_EN_POURCENTAGE / 100)
	}

	if (danger && danger==="true") {
		_price += (distanceKM * perKM + currentTarif.Tarif_DE_PRISE_EN_CHARGE) * (currentTarif.FRIGORIFIQUE_EN_POURCENTAGE / 100)
	}

	return _price
}


export function computePriceMiseADispoV2(tarif, totalMissions) {
	// Extract and convert values
	const distanceKM = Number(totalMissions?.kilo_jour) || 0
	const heures = Number(totalMissions?.heures) || 0
	const heureSupp = Math.max(0, heures - 7)
	const rippeursValue =
		totalMissions?.nbrRippeur === '' ? 0 : Number(totalMissions?.nbrRippeur)
	const nombreEtagesValue = totalMissions?.nombreEtage
	const typeTransportValue = totalMissions?.typeTransport
	const optionsVehiculeLegerValue = totalMissions?.optionsVehiculeLeger
	const optionsPoidsLourdsValue = totalMissions?.optionsPoidsLourds
	const dangerValue = totalMissions?.danger === 'true'

	// Special case for Semi
	if (typeTransportValue === 'Semi') {
		let _price = tarif.SEMI.TARIF_SEMI_PAR_24H

		if (optionsPoidsLourdsValue?.includes('Frigorifique')) {
			_price +=
				_price * (tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
		}

		if (rippeursValue) {
			_price +=
				tarif.SEMI.TARIF_SEMI_PAR_24H *
				(rippeursValue *
					heures *
					tarif.SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS)
		}

		return _price
	}

	// Get vehicle type configuration
	const vehicleConfig = {
		Break: tarif.BREAK,
		'Fourgon 12m³': tarif.F12,
		'Fourgon 14m³': tarif.F14,
		'Camion 20m³': tarif.F20,
		'7,5 Tonnes': tarif.V7_5T,
		'12 Tonnes': tarif.V12T,
		'19 Tonnes': tarif.V19T,
		Tracteur: tarif.TRACTEUR,
		'Tracteur+semi': tarif.TRACTEUR_SEMI,
	}[typeTransportValue]

	if (!vehicleConfig) return 0

	// Calculate base price
	let _price = vehicleConfig.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
	// Add price for distance exceeding 200km
	if (distanceKM > 200) {
		_price +=
			(distanceKM - 200) * (vehicleConfig.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM/2)
	}

	// Calculate base price for frigorific option and danger
	const baseForSurcharges = _price

	// Add frigorific option if applicable
	const isLightVehicle = [
		'Break',
		'Fourgon 12m³',
		'Fourgon 14m³',
		'Camion 20m³',
	].includes(typeTransportValue) 
	const hasFrigorific =
		(isLightVehicle &&
			optionsVehiculeLegerValue?.includes('Frigorifique')) ||
		(!isLightVehicle && optionsPoidsLourdsValue?.includes('Frigorifique'))

	if (hasFrigorific) {
		_price +=
			baseForSurcharges *
			(vehicleConfig.FRIGORIFIQUE_EN_POURCENTAGE / 100)
	}

	// Add danger surcharge if applicable
	if (dangerValue) {
		_price +=
			baseForSurcharges *
			(vehicleConfig.FRIGORIFIQUE_EN_POURCENTAGE / 100)
	}

	// Add price for floors
	if (nombreEtagesValue === '1-10') {
		_price += vehicleConfig.TARIF_PAR_1_10_ETAGE
	} else if (nombreEtagesValue === '11-20') {
		_price += vehicleConfig.TARIF_PAR_11_20_ETAGE
	} else if (nombreEtagesValue === '21-30') {
		_price += vehicleConfig.TARIF_PAR_21_30_ETAGE
	}

	// Add price for additional workers (rippeurs)
	if (rippeursValue) {
		_price +=
			heures *
			rippeursValue *
			vehicleConfig.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
	}

	// Add price for extra hours
	if (heureSupp > 0) {
		_price += heureSupp * vehicleConfig.TARIF_PAR_HEURE_DE_MISE_À_DISPO
	}

	return _price
}

export function computePriceMiseADispo(tarif, totalMissions) {
	let _price = 0
	const distanceKM = Number(totalMissions?.kilo_jour)
	const heures = Number(totalMissions?.heures)
	const heureSupp = Number(totalMissions?.heures) - 7
	const rippeursValue =
		totalMissions?.nbrRippeur === '' ? 0 : Number(totalMissions?.nbrRippeur)
	const nombreEtagesValue = totalMissions?.nombreEtage
	const typeTransportValue = totalMissions?.typeTransport
	const optionsVehiculeLegerValue = totalMissions?.optionsVehiculeLeger
	const optionsPoidsLourdsValue = totalMissions?.optionsPoidsLourds
	const dangerValue = totalMissions?.danger

	switch (typeTransportValue) {
		case 'Break': {
			if (distanceKM === 200) {
				_price = tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif?.BREAK?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif?.BREAK
							?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.BREAK
									?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif?.BREAK
							?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.BREAK
									?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}
			if (nombreEtagesValue === '1-10') {
				_price += tarif?.BREAK?.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif?.BREAK?.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif?.BREAK?.TARIF_PAR_21_30_ETAGE
			}
			if (rippeursValue) {
				_price +=
					heures *
					rippeursValue *
					tarif?.BREAK?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price +=
					heureSupp * tarif?.BREAK?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Fourgon 12m³': {
			if (distanceKM <= 200) {
				_price = tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}
			if (nombreEtagesValue === '1-10') {
				_price += tarif?.F12?.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif?.F12?.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif?.F12?.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					heures *
					rippeursValue *
					tarif?.F12?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price +=
					heureSupp * tarif?.F12?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			break
		}

		case 'Fourgon 14m³': {
			if (distanceKM <= 200) {
				_price = tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.F14?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F14?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.F14?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F14?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F14.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F14.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.F14.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.F14.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.F14.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					heures *
					rippeursValue *
					tarif.F14.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price += heureSupp * tarif.F14.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Camion 20m³': {
			if (distanceKM <= 200) {
				_price = tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.F20.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.F20.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.F20.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heures *
					tarif.F20.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}

			if (heureSupp && heureSupp > 0) {
				_price += heureSupp * tarif.F20.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '7,5 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.V7_5T.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.V7_5T.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.V7_5T.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					heures *
					rippeursValue *
					tarif.V7_5T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price +=
					heureSupp * tarif.V7_5T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '12 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.V12T.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.V12T.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.V12T.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heures *
					tarif.V12T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price += heureSupp * tarif.V12T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '19 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.V19T.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.V19T.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.V19T.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heures *
					tarif.V19T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price += heureSupp * tarif.V19T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			break
		}

		case 'Tracteur': {
			if (distanceKM <= 200) {
				_price = tarif.TRACTEUR.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.TRACTEUR.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.TRACTEUR.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.TRACTEUR.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.TRACTEUR.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.TRACTEUR.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heures *
					tarif.TRACTEUR.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price +=
					heureSupp * tarif.TRACTEUR.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Semi': {
			_price = tarif.SEMI.TARIF_SEMI_PAR_24H
			if (
				optionsPoidsLourdsValue &&
				optionsPoidsLourdsValue.includes('Frigorifique')
			) {
				_price +=
					_price * (tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
			}

			if (rippeursValue) {
				_price +=
					tarif.SEMI.TARIF_SEMI_PAR_24H *
					(rippeursValue *
						heures *
						tarif.SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS)
			}

			break
		}

		case 'Tracteur+semi': {
			if (distanceKM <= 200) {
				_price =
					tarif.TRACTEUR_SEMI.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.TRACTEUR_SEMI
						.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.TRACTEUR_SEMI.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR_SEMI
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR_SEMI
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (nombreEtagesValue === '1-10') {
				_price += tarif.TRACTEUR_SEMI.TARIF_PAR_1_10_ETAGE
			} else if (nombreEtagesValue === '11-20') {
				_price += tarif.TRACTEUR_SEMI.TARIF_PAR_11_20_ETAGE
			} else if (nombreEtagesValue === '21-30') {
				_price += tarif.TRACTEUR_SEMI.TARIF_PAR_21_30_ETAGE
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heures *
					tarif.TRACTEUR_SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (heureSupp && heureSupp > 0) {
				_price +=
					heureSupp *
					tarif.TRACTEUR_SEMI.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		default:
			break
	}

	return _price
}
export function computePriceForfait(tarif, mission, forfait, totalHours) {
	let _price = 0
	const distanceKM = Number(forfait)
	const existeForfaitKilometrage = mission?.forfaits?.some(
		(forfait) =>
			forfait.type === 'kilometrage' ||
			forfait.type === 'kilometrage_etage'
	)
	const existeForfaitHeure = mission?.forfaits?.some(
		(forfait) => forfait.type === 'heure' || forfait.type === 'heure_etage'
	)
	const rippeursValue = mission?.nombre_rippeur
		? Number(mission?.nombre_rippeur)
		: 0
	const rippeurHoursValue = existeForfaitKilometrage ? 0 : 12 - totalHours
	const typeTransportValue =
		mission?.type_transport_details || mission?.vehicule_poids_lourds
	const optionsVehiculeLegerValue = mission?.options_vehicule_leger
	const optionsPoidsLourdsValue = mission?.options_poids_lourds
	const dangerValue = mission?.danger
	switch (typeTransportValue) {
		case 'Break': {
			if (distanceKM === 200) {
				_price = tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif?.BREAK?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif?.BREAK?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif?.BREAK
							?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.BREAK
									?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif?.BREAK
							?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.BREAK
									?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.BREAK?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeurHoursValue) *
					Number(rippeursValue) *
					tarif?.BREAK?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.BREAK?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Fourgon 12m³': {
			if (distanceKM <= 200) {
				_price = tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif?.F12?.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeurHoursValue) *
					Number(rippeursValue) *
					tarif?.F12?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.F12?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Fourgon 14m³': {
			if (distanceKM <= 200) {
				_price = tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif?.F12?.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif?.F12?.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F14.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.F14.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F14.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F14.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeurHoursValue) *
					Number(rippeursValue) *
					tarif.F14.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.F14?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Camion 20m³': {
			if (distanceKM <= 200) {
				_price = tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsVehiculeLegerValue &&
					optionsVehiculeLegerValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.F20.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.F20.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.F20.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeursValue) *
					Number(rippeurHoursValue) *
					tarif.F20.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.F20?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '7,5 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V7_5T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V7_5T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V7_5T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeurHoursValue) *
					Number(rippeursValue) *
					tarif.V7_5T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.V7_5T?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '12 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V12T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V12T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V12T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeursValue) *
					Number(rippeurHoursValue) *
					tarif.V12T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.V12T?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case '19 Tonnes': {
			if (distanceKM <= 200) {
				_price = tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.V19T.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.V19T.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.V19T.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeursValue) *
					Number(rippeurHoursValue) *
					tarif.V19T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.V19T?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Tracteur': {
			if (distanceKM <= 200) {
				_price = tarif.TRACTEUR.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.TRACTEUR.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.TRACTEUR.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.TRACTEUR
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeursValue) *
					Number(rippeurHoursValue) *
					tarif.TRACTEUR.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.TRACTEUR?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Semi': {
			_price = tarif.SEMI.TARIF_SEMI_PAR_24H
			if (
				optionsPoidsLourdsValue &&
				optionsPoidsLourdsValue.includes('Frigorifique')
			) {
				_price +=
					_price * (tarif.TRACTEUR.FRIGORIFIQUE_EN_POURCENTAGE / 100)
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					tarif.SEMI.TARIF_SEMI_PAR_24H *
					(Number(rippeursValue) *
						Number(rippeurHoursValue) *
						tarif.SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS)
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.SEMI?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		case 'Tracteur+semi': {
			if (distanceKM <= 200) {
				_price =
					tarif.TRACTEUR_SEMI.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			} else {
				_price =
					tarif.TRACTEUR_SEMI
						.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
					(distanceKM - 200) *
						tarif.TRACTEUR_SEMI.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM
				if (
					optionsPoidsLourdsValue &&
					optionsPoidsLourdsValue.includes('Frigorifique')
				) {
					_price +=
						(tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR_SEMI
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
				if (dangerValue && dangerValue === 'true') {
					_price +=
						(tarif.TRACTEUR_SEMI
							.TARIFS_EN_EUROS_POUR_200KM_JOURS_POUR_7H +
							(distanceKM - 200) *
								tarif.TRACTEUR_SEMI
									.TARIFS_EN_EUROS_DÉPACEMENT_AU_KM) *
						(tarif.TRACTEUR_SEMI.FRIGORIFIQUE_EN_POURCENTAGE / 100)
				}
			}

			if (rippeursValue && rippeurHoursValue) {
				_price +=
					Number(rippeursValue) *
					Number(rippeurHoursValue) *
					tarif.TRACTEUR_SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			if (existeForfaitHeure) {
				const heureChaufffeur =
					mission?.forfaits?.reduce((total, forfait) => {
						if (['heure', 'heure_etage'].includes(forfait?.type)) {
							const [hours, minutes] = forfait?.details?.heures
								.split(':')
								.map(Number)
							return total + hours * 60 + minutes
						}
						return total
					}, 0) / 60 || 0
				_price -=
					heureChaufffeur *
					tarif?.TRACTEUR_SEMI?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			break
		}

		default:
			break
	}

	return _price
}
export function computePriceEtage(tarif, mission, etage) {
	let _price = 0
	const typeTransportValue =
		mission?.type_transport_details || mission?.vehicule_poids_lourds
	switch (typeTransportValue) {
		case 'Break': {
			if (etage === '1-10') {
				_price = tarif?.BREAK?.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif?.BREAK?.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif?.BREAK?.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case 'Fourgon 12m³': {
			if (etage === '1-10') {
				_price = tarif?.F12?.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif?.F12?.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif?.F12?.TARIF_PAR_21_30_ETAGE
			}
			break
		}

		case 'Fourgon 14m³': {
			if (etage === '1-10') {
				_price = tarif.F14.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.F14.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.F14.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case 'Camion 20m³': {
			if (etage === '1-10') {
				_price = tarif.F20.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.F20.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.F20.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case '7,5 Tonnes': {
			if (etage === '1-10') {
				_price = tarif.V7_5T.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.V7_5T.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.V7_5T.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case '12 Tonnes': {
			if (etage === '1-10') {
				_price = tarif.V12T.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.V12T.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.V12T.TARIF_PAR_21_30_ETAGE
			}
			break
		}

		case '19 Tonnes': {
			if (etage === '1-10') {
				_price = tarif.V19T.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.V19T.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.V19T.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case 'Tracteur': {
			if (etage === '1-10') {
				_price = tarif.TRACTEUR.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.TRACTEUR.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.TRACTEUR.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		case 'Semi': {
			break
		}

		case 'Tracteur+semi': {
			if (etage === '1-10') {
				_price = tarif.TRACTEUR_SEMI.TARIF_PAR_1_10_ETAGE
			} else if (etage === '11-20') {
				_price = tarif.TRACTEUR_SEMI.TARIF_PAR_11_20_ETAGE
			} else if (etage === '21-30') {
				_price = tarif.TRACTEUR_SEMI.TARIF_PAR_21_30_ETAGE
			}

			break
		}

		default:
			break
	}

	return _price
}
export function computePriceHeure(tarif, mission, heure) {
	let _price = 0
	const [heures, minutes] = heure?.split(':').map(Number)
	const heureSupp = heures + minutes / 60
	const typeTransportValue =
		mission?.type_transport_details || mission?.vehicule_poids_lourds
	const rippeursValue = mission?.nombre_rippeur
		? Number(mission?.nombre_rippeur)
		: 0

	switch (typeTransportValue) {
		case 'Break': {
			if (heureSupp && heureSupp > 0) {
				_price =
					heureSupp * tarif?.BREAK?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					heureSupp *
					rippeursValue *
					tarif?.BREAK?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			break
		}

		case 'Fourgon 12m³': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif?.F12?.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					heureSupp *
					rippeursValue *
					tarif?.F12?.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			break
		}

		case 'Fourgon 14m³': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif.F14.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					heureSupp *
					rippeursValue *
					tarif.F14.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}

			break
		}

		case 'Camion 20m³': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif.F20.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}

			if (rippeursValue) {
				_price +=
					rippeursValue *
					heureSupp *
					tarif.F20.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}

			break
		}

		case '7,5 Tonnes': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif.V7_5T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					heureSupp *
					rippeursValue *
					tarif.V7_5T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			break
		}

		case '12 Tonnes': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif.V12T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					rippeursValue *
					heureSupp *
					tarif.V12T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			break
		}

		case '19 Tonnes': {
			if (heureSupp && heureSupp > 0) {
				_price = heureSupp * tarif.V19T.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					rippeursValue *
					heureSupp *
					tarif.V19T.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}
			break
		}

		case 'Tracteur': {
			if (heureSupp && heureSupp > 0) {
				_price =
					heureSupp * tarif.TRACTEUR.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					rippeursValue *
					heureSupp *
					tarif.TRACTEUR.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}

			break
		}

		case 'Semi': {
			break
		}

		case 'Tracteur+semi': {
			if (heureSupp && heureSupp > 0) {
				_price =
					heureSupp *
					tarif.TRACTEUR_SEMI.TARIF_PAR_HEURE_DE_MISE_À_DISPO
			}
			if (rippeursValue) {
				_price +=
					rippeursValue *
					heureSupp *
					tarif.TRACTEUR_SEMI.TARIFS_PAR_RIPPEUR_PAR_HEURE_EN_EUROS
			}

			break
		}

		default:
			break
	}

	return _price
}
